export default __webpack_public_path__ + "static/media/our-partner-logo-11.e9f4b99f.jpeg";